import { Injectable } from '@angular/core';
import { ApiAutoCompleteService, FieldSelectOption } from 'components/shared';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CodeWrapperService } from '../service-wrappers/code-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class DischargeStatusLookupService extends ApiAutoCompleteService {
  constructor(private service: CodeWrapperService) {
    super();
  }

  codeType: string = 'DischargeStatus';
   existingValue: string = '';

  mapRow(result) {
    return {
      code: result.code,
      value: result.id,
      label: result.name
    };
  }

    mapRowRule(result) {
    return {
      code: result.code,
      value: result.id,
      label: result.code + '-' + result.name,
      inactive: result.inactive
    };
  }

  search(value: string): Observable<FieldSelectOption[]> {
    return this.service
      .apiV1CodeCodetypePost(this.codeType, { generalSearch: value, pageSize: 100 })
      .pipe(map((results) => results.data.map(this.mapRow)));
  }

  load(id: string): Observable<FieldSelectOption> {
    return this.service.apiV1CodeCodetypeIdGet(this.codeType, id).pipe(map(this.mapRow));
  }

   searchForRule(value: string): Observable<FieldSelectOption[]> {
      return this.service
        .apiV1CodeCodetypePost(this.codeType, { generalSearch: value, pageSize: 1000 })
        .pipe(map((results) => results.data.map(this.mapRowRule).filter((x: any) => !x.inactive || x.value === this.existingValue || x.code === this.existingValue)));
    }
}
